import ColorsStyles from '@Styles/colors.scss';
import { ButtonProps, Button as MuiButton } from '@mui/material';
import { styled } from '@mui/system';
import React from 'react';

export const getBtnColor = (color: any, isHover = false): string => {
    switch (color) {
        case 'indigo':
            return isHover
                ? ColorsStyles.ikeSecondaryLightIndigo
                : ColorsStyles.ikeSecondaryDarkIndigo;
        case 'blue':
            return isHover
                ? ColorsStyles.ikeSecondaryLightBlue
                : ColorsStyles.ikeSecondaryDarkBlue;
        case 'red':
        case 'error':
            return isHover
                ? ColorsStyles.ikeSecondaryLightRed
                : ColorsStyles.ikeSecondaryDarkRed;
        case 'green':
        case 'success':
            return isHover
                ? ColorsStyles.ikeSecondaryLightGreen
                : ColorsStyles.ikeSecondaryDarkGreen;
        case 'black':
            return isHover
                ? ColorsStyles.ikeGradient4
                : ColorsStyles.ikeGradient1;
        case 'gray':
            return ColorsStyles.ikeGradient9;
        default:
            return '#FFF';
    }
};

const StyledButton = styled(MuiButton)(
    ({ color }) => `
    font-family: 'Barlow';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;    
    display: flex;
    align-items: center;
    letter-spacing: 0.02em;    
    color: #FFFFFF;
    padding: 7px 10px 8px;

    background-color: ${getBtnColor(color)};

    &:hover {
        background-color: ${getBtnColor(color, true)}
    }
`
);

const Button = (props: ButtonProps) => {
    return <StyledButton {...props} />;
};

export default Button;
